import { useUser } from '../../contexts/user/user-context'
import { Onboarding } from './onboarding'

export function OnboardingContainer() {
    const { userProfile } = useUser()

    return <Onboarding firstName={userProfile?.firstName ?? 'User'} />
}
